// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 内容主视频发表评论 POST /team/video/comment */
export async function teamVideoCommentUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.teamVideoCommentUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/team/video/comment', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 内容主视频信息 GET /team/video/info */
export async function teamVideoInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.teamVideoInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultTeamShortVideoResp>('/team/video/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
